import * as React from 'react';
export const GYSvg = React.forwardRef(function GYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-1 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        x: 1,
        fill: '#24B47E',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M0 9.991V2.01l.001-.077C.039.717 1.152-.013 2.27.417L17.988 6l-2.653.942-13.041 4.632C1.152 12.013.04 11.294 0 10.06v-.069Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1 9.991V1.964c.017-.52.429-.8.935-.604L15 6 1.935 10.64c-.506.195-.918-.074-.934-.602L1 9.991Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M1.664 11.488A2.01 2.01 0 0 1 1 9.99V2.01c0-.594.257-1.128.665-1.497.043.023.086.052.131.085L9 6l-7.204 5.403a1.03 1.03 0 0 1-.132.085Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.16 10.781a2.012 2.012 0 0 1-.16-.79V2.01c0-.338.083-.656.23-.936L7.5 6c-3.233 2.584-5.347 4.178-6.34 4.781Z',
      }),
    ),
  );
});
GYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GY = {
  category: 'flag',
  colorable: false,
  name: 'GY',
  svg: GYSvg,
};
